<template>
  <v-container fluid>
    <h2>{{ title }}</h2>
    <div class="text-right">
      <v-btn color="primary" :to="{name:'billet_creation'}">
        <v-icon>mdi-plus</v-icon>{{ $tc('ticket.create') }}
      </v-btn>
    </div>

    <v-row class="mb-2">
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-select
          v-show="showStatus"
          v-model="status"
          :items="
              (status_option || []).map((option) => ({
                text: $langobj.parse(option.name_lang),
                value: option.status_id,
              }))"
          :label="$tc('ticket.status')"
          clearable
          @change="newStart"
        ></v-select>
      </v-col>
      <v-col cols="2" v-if="!typeKeyFilter">
        <v-select
          v-model="type_key"
          :items="
              (ticket_type_option || []).map((option) => ({
                text: $langobj.parse(option.name),
                value: option.ticket_type_key,
              }))"
          :label="$tc('ticket.type')"
          clearable
          @change="loadStatus"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="responsable"
          :items="responsable_option"
          item-text="responsable_name"
          item-value="user_id"
          :label="$tc('ticket.responsable')"
          clearable
          @change="newStart"
        ></v-select>
      </v-col>
      <v-col cols="2">
        <v-text-field
          v-model="keywords"
          append-icon="mdi-magnify"
          :label="$tc('label.search')"
          single-line
          hide-details
          @input="debounceSearch()"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :items-per-page="20"
      :footer-props="{itemsPerPageOptions:[20,50,100]}"
      dense
      :headers="headers"
      :options.sync="options"
      :items="localeAwareItems"
      :server-items-length="totalRecords"
      item-key="element_id"
      :loading="isLoading"
      @click:row="handleRowClick"
    >
      <template v-slot:[`item.created_at`]="{ item }">
        {{ moment.utc(item.created_at).local().format('YYYY-MM-DD') }}
      </template>
      <template v-slot:[`item.responsable`]="{ item }">
        <user-avatar :user="item.responsable" class="mr-2"/>
        {{ item.responsable.full_name }}
      </template>
    </v-data-table>

  </v-container>
</template>

<script>

import UserAvatar from '@/components/user/UserAvatar.vue';

function scrollToTop(){
  window.setTimeout(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, 200);
}

export default {
  props: ['typeKeyFilter'],
  data: function() {return {
    options: {},
    keywords:'',
    tickets: [],

    type_resolution: '',

    // filter
    ticket_type_option: [],
    responsable_option: [],
    // requirement_option: [],
    service_provider_option: [],
    status_option: [],
    type_key: null,
    service_provider_id: null,
    requirement: null,
    responsable: null,
    status:null,
    // showStatus:false,

    totalRecords: 0,
    isLoading: false
  }},

  name: 'ProviderTicketList',
  components: {
    UserAvatar
  },

  computed: {
    localeAwareItems() {
      return this.tickets
        .map(item => {
          return {...item,
            service_provider: this.$langobj.parse(item.service_provider_lang),
            ticket_status_lang: this.$langobj.parse(item.ticket_status_lang),
            ticket_type_lang: this.$langobj.parse(item.ticket_type_lang),
          };
        })
    },
    showStatus() {
      return this.status_option.length > 0 && (this.typeKeyFilter || this.type_key)
    },
    title() {
      if(this.typeKeyFilter == 'note')
        return this.$tc('navigation.note', 2)
      return this.$tc('navigation.ticket', 2);
    },
    headers() {
      if(this.typeKeyFilter == 'note')
        return [
          { text: this.$tc('ticket.title'), value: 'title' },
          { text: this.$t('ticket.created_at'), value: 'created_at' },
          { text: this.$t('ticket.effective_at'), value: 'effective_at' },
          { text: this.$tc('ticket.responsable'), value: 'responsable', sortable: false },
          { text: this.$tc('ticket.status'), value: 'ticket_status_lang', sortable: false },
        ];
      return [
        { text: this.$tc('ticket.type'), value: 'ticket_type_lang' },
        { text: this.$tc('ticket.title'), value: 'title' },
        { text: this.$t('ticket.created_at'), value: 'created_at' },
        { text: this.$t('ticket.due_date'), value: 'due_date' },
        { text: this.$tc('ticket.responsable'), value: 'responsable', sortable: false },
        { text: this.$tc('ticket.status'), value: 'ticket_status_lang', sortable: false },
      ];
    }
  },
  methods: {
    handleRowClick(row) {
      this.$router.push(
        { name: 'billet', params: { ticket_id: row.element_id }}
      );
    },

    debounceSearch: function(val){
      if(this.search_timeout) clearTimeout(this.search_timeout);
      
      const self = this;
      this.search_timeout = setTimeout(function() {
        self.getDataFromApi();
      }, 250);
    },

    newStart: function () {
      this.getDataFromApi();
      this.loadFilters();
    },

    loadFilters: function() {
      this.$axios
        .get(this.$root.$data.server_base + '/api/ticket/ticket_filter_dropdown.php',
          { })
        .then(response => {
          this.ticket_type_option = response.data.ticket_type;
          this.responsable_option = response.data.responsable;
          this.service_provider_option = response.data.service_provider;
        })
    },

    loadStatus: function()
    {
      this.$axios
        .get(this.$root.$data.server_base + '/api/ticket/ticket_dropdown_status.php',
          { params:{ticket_type_key: this.typeKeyFilter || this.type_key}})
        .then(response => (
          this.status_option = response.data.ticket_status,
          this.status=null
        ))
    },

    getDataFromApi () {
      this.isLoading = true;

      this.$axios
        .get(this.$root.$data.server_base + '/api/ticket/get_list.php',
          { params: {
            sort: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 0 : 1,
            type_key: this.typeKeyFilter || this.type_key,
            ticket_resolution: this.ticket_resolution,
            status: this.status,
            service_provider_id: this.$route.params.service_provider_id,
            requirement: this.requirement,
            responsable: this.responsable,
            keywords: this.keywords,
            page: this.options.page,
            page_size: this.options.itemsPerPage
          }})
        .then(response => {
          this.$checkApiErrors(response.data);
          this.tickets = response.data.tickets;
          this.totalRecords = response.data.total;
          this.isLoading = false
          scrollToTop()
        })
    }

  },
  watch: {
    options: {
      handler () {
        this.getDataFromApi()
      },
      deep: true,
    },
    $route() {
      // A route change occurs when clicking on the side menu
      this.service_provider_id=this.$route.query.service_provider_id || '';
      this.type_key=this.$route.query.type_key || '';
      this.ticket_resolution=this.$route.query.ticket_resolution || '';
      this.responsable=this.$route.query.responsable || '';
      this.getDataFromApi();
      this.loadFilters();
    }
  },
  mounted () {
    this.service_provider_id=this.$route.query.service_provider_id || '';
    this.type_key=this.$route.query.type_key || '';
    this.ticket_resolution=this.$route.query.ticket_resolution || '';
    this.responsable=this.$route.query.responsable || '';
    this.getDataFromApi();
    this.loadFilters();
    if(this.typeKeyFilter)
      this.loadStatus();
  }
}
</script>
